import Button from "components/BaseWidgets/button";
import "./style.scss";
import { BackArrow } from "assets/icons";
import Input from "components/BaseWidgets/form/input";
import DatePicker from "components/BaseWidgets/datePicker";
import CustomTextArea from "components/BaseWidgets/form/textArea";
import FooterButton from "components/Settings/components/FooterButton";
import PhotoDragUpload from "components/CustomWidgets/PhotoDragUpload";
import { useState } from "react";
import { usesuccessStories } from "hooks/api/useSettings";
import dayjs from "dayjs";
import { retrieveToken } from "utils/storage";

function SuccessStory({ setOpen }) {
  const [partnerProfileId, setPartnerProfileId] = useState("");
  const [title, setTitle] = useState("");
  const [head, setHead] = useState("");
  const [body, setBody] = useState("");
  const [dateOfMarriage, setDateOfMarriage] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [storyId, setStoryId] = useState("");
  const [errors, setErrors] = useState({});
  const user = JSON.parse(retrieveToken("user"));
  const user_aec_id = user?.aec_id;

  const { mutate: successStories, isLoading: updateLoading } =
    usesuccessStories({
      onSuccess: () => {
        setOpen(false);
      },
    });

  const buildPayload = () => {
    const formData = new FormData();
    formData.append("partner_profile_id", partnerProfileId);
    formData.append("title", title);
    formData.append("body", body);
    formData.append(
      "date_of_marriage",
      dateOfMarriage ? dateOfMarriage.toISOString().split("T")[0] : "",
    );

    if (head) formData.append("head", head);
    if (storyId) formData.append("story_id", storyId);

    fileList.forEach((file) => {
      formData.append("images", file.originFileObj || file);
    });

    return formData;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = "Story name is required.";
    }

    if (!partnerProfileId.trim()) {
      newErrors.partnerProfileId = "Partner profile ID is required.";
    } else if (partnerProfileId === String(user_aec_id)) {
      newErrors.partnerProfileId =
        "Partner profile ID cannot be your own profile ID.";
    }

    if (!dateOfMarriage) {
      newErrors.dateOfMarriage = "Date of marriage is required.";
    }

    if (!body.trim()) {
      newErrors.body = "Story details are required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSave = () => {
    if (!validateForm()) return;

    const payload = buildPayload();
    successStories(payload);
  };

  return (
    <div className="settings-success-story">
      <div className="flex items-center gap-3">
        <Button onClick={() => setOpen(false)} variant="custom" height={24}>
          <BackArrow />
        </Button>
        <h1 className="font-title-lg fw-700">Add success story</h1>
      </div>
      <div className="card-wrapper">
        <div className="w-full">
          <Input
            label="Story name"
            labelClass="fw-400"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          {errors.title && <p className="error-text">{errors.title}</p>}
        </div>

        <div className="flex items-center gap-4">
          <div className="w-full">
            <Input
              label="Your partner’s profile id"
              value={partnerProfileId}
              onChange={(e) => setPartnerProfileId(e.target.value)}
              labelClass="fw-400"
            />
            {errors.partnerProfileId && (
              <p className="error-text">{errors.partnerProfileId}</p>
            )}
          </div>

          <div className="w-full">
            <DatePicker
              label="Date of marriage"
              wrapperClass="w-full"
              labelClass="fw-400"
              value={dateOfMarriage}
              onChange={(date) => setDateOfMarriage(date)}
              placeholder=""
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
            />
            {errors.dateOfMarriage && (
              <p className="error-text">{errors.dateOfMarriage}</p>
            )}
          </div>
        </div>

        <div className="w-full">
          <CustomTextArea
            labelClass="fw-400"
            label="Tell us more..."
            placeholder="Start writing..."
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
          {errors.body && <p className="error-text">{errors.body}</p>}
        </div>

        <div className="flex flex-col gap-1-5 w-full">
          <label htmlFor="" className="input-label fw-400">
            Add photo
          </label>
          <PhotoDragUpload fileList={fileList} setFileList={setFileList} />
        </div>
      </div>

      <FooterButton
        isLoading={updateLoading}
        onSave={handleSave}
        onCancel={() => setOpen(false)}
      />
    </div>
  );
}

export default SuccessStory;
